/**
 * Historical daily-close context retrieved from Yahoo Finance on 13 October 2026.
 * This static dataset powers contextual charts only; it is not a market-data feed or investment recommendation.
 */

export type AIInfrastructureStockSeries = {
  symbol: string;
  company: string;
  asOf: string;
  points: Array<{ date: string; close: number }>;
};

export const AI_INFRASTRUCTURE_STOCK_SERIES: Record<string, AIInfrastructureStockSeries> = {
  "spacex-nvidia-ai-infrastructure-financing-2026": {
    "symbol": "SPCX",
    "company": "Space Exploration Technologies Corp.",
    "asOf": "13 October 2026",
    "points": [
      {
        "date": "2026-07-13",
        "close": 139.14
      },
      {
        "date": "2026-07-14",
        "close": 136.08
      },
      {
        "date": "2026-07-15",
        "close": 135.27
      },
      {
        "date": "2026-07-16",
        "close": 131.11
      },
      {
        "date": "2026-07-17",
        "close": 123.99
      },
      {
        "date": "2026-07-20",
        "close": 119.85
      },
      {
        "date": "2026-07-21",
        "close": 123.54
      },
      {
        "date": "2026-07-22",
        "close": 115.26
      },
      {
        "date": "2026-07-23",
        "close": 118.24
      },
      {
        "date": "2026-07-24",
        "close": 115.07
      },
      {
        "date": "2026-07-27",
        "close": 113.5
      },
      {
        "date": "2026-07-28",
        "close": 116.41
      },
      {
        "date": "2026-07-29",
        "close": 112.55
      },
      {
        "date": "2026-07-30",
        "close": 112.2
      },
      {
        "date": "2026-07-31",
        "close": 108.37
      },
      {
        "date": "2026-08-03",
        "close": 114.53
      },
      {
        "date": "2026-08-04",
        "close": 125.33
      },
      {
        "date": "2026-08-05",
        "close": 108.27
      },
      {
        "date": "2026-08-06",
        "close": 114.92
      },
      {
        "date": "2026-08-07",
        "close": 133.11
      },
      {
        "date": "2026-08-10",
        "close": 138.74
      },
      {
        "date": "2026-08-11",
        "close": 133.29
      },
      {
        "date": "2026-08-12",
        "close": 146.15
      },
      {
        "date": "2026-08-13",
        "close": 141.29
      },
      {
        "date": "2026-08-14",
        "close": 140.0
      },
      {
        "date": "2026-08-17",
        "close": 146.23
      },
      {
        "date": "2026-08-18",
        "close": 143.34
      },
      {
        "date": "2026-08-19",
        "close": 139.65
      },
      {
        "date": "2026-08-20",
        "close": 134.0
      },
      {
        "date": "2026-08-21",
        "close": 136.97
      },
      {
        "date": "2026-08-24",
        "close": 135.0
      },
      {
        "date": "2026-08-25",
        "close": 137.95
      },
      {
        "date": "2026-08-26",
        "close": 139.63
      },
      {
        "date": "2026-08-27",
        "close": 140.87
      },
      {
        "date": "2026-08-28",
        "close": 141.5
      },
      {
        "date": "2026-08-31",
        "close": 143.69
      },
      {
        "date": "2026-09-01",
        "close": 142.23
      },
      {
        "date": "2026-09-02",
        "close": 140.71
      },
      {
        "date": "2026-09-03",
        "close": 149.74
      },
      {
        "date": "2026-09-04",
        "close": 147.95
      },
      {
        "date": "2026-09-08",
        "close": 153.47
      },
      {
        "date": "2026-09-09",
        "close": 147.55
      },
      {
        "date": "2026-09-10",
        "close": 148.18
      },
      {
        "date": "2026-09-11",
        "close": 151.21
      },
      {
        "date": "2026-09-14",
        "close": 148.15
      },
      {
        "date": "2026-09-15",
        "close": 143.49
      },
      {
        "date": "2026-09-16",
        "close": 150.88
      },
      {
        "date": "2026-09-17",
        "close": 154.81
      },
      {
        "date": "2026-09-18",
        "close": 152.71
      },
      {
        "date": "2026-09-21",
        "close": 151.85
      },
      {
        "date": "2026-09-22",
        "close": 154.72
      },
      {
        "date": "2026-09-23",
        "close": 148.36
      },
      {
        "date": "2026-09-24",
        "close": 148.03
      },
      {
        "date": "2026-09-25",
        "close": 148.68
      },
      {
        "date": "2026-09-28",
        "close": 145.47
      },
      {
        "date": "2026-09-29",
        "close": 149.24
      },
      {
        "date": "2026-09-30",
        "close": 150.86
      },
      {
        "date": "2026-10-01",
        "close": 148.07
      },
      {
        "date": "2026-10-02",
        "close": 158.96
      },
      {
        "date": "2026-10-05",
        "close": 171.09
      },
      {
        "date": "2026-10-06",
        "close": 171.92
      },
      {
        "date": "2026-10-07",
        "close": 167.6
      },
      {
        "date": "2026-10-08",
        "close": 160.57
      },
      {
        "date": "2026-10-09",
        "close": 162.57
      },
      {
        "date": "2026-10-12",
        "close": 163.42
      }
    ]
  },
  "ast-spacemobile-bluebird-satellite-analyst-rating-2026": {
    "symbol": "ASTS",
    "company": "AST SpaceMobile, Inc.",
    "asOf": "13 October 2026",
    "points": [
      {
        "date": "2026-07-13",
        "close": 67.58
      },
      {
        "date": "2026-07-14",
        "close": 68.82
      },
      {
        "date": "2026-07-15",
        "close": 66.31
      },
      {
        "date": "2026-07-16",
        "close": 55.01
      },
      {
        "date": "2026-07-17",
        "close": 57.8
      },
      {
        "date": "2026-07-20",
        "close": 57.42
      },
      {
        "date": "2026-07-21",
        "close": 63.34
      },
      {
        "date": "2026-07-22",
        "close": 61.95
      },
      {
        "date": "2026-07-23",
        "close": 59.18
      },
      {
        "date": "2026-07-24",
        "close": 56.2
      },
      {
        "date": "2026-07-27",
        "close": 58.29
      },
      {
        "date": "2026-07-28",
        "close": 56.55
      },
      {
        "date": "2026-07-29",
        "close": 53.03
      },
      {
        "date": "2026-07-30",
        "close": 58.44
      },
      {
        "date": "2026-07-31",
        "close": 58.98
      },
      {
        "date": "2026-08-03",
        "close": 63.52
      },
      {
        "date": "2026-08-04",
        "close": 70.31
      },
      {
        "date": "2026-08-05",
        "close": 68.38
      },
      {
        "date": "2026-08-06",
        "close": 67.36
      },
      {
        "date": "2026-08-07",
        "close": 71.94
      },
      {
        "date": "2026-08-10",
        "close": 68.76
      },
      {
        "date": "2026-08-11",
        "close": 71.63
      },
      {
        "date": "2026-08-12",
        "close": 74.31
      },
      {
        "date": "2026-08-13",
        "close": 71.52
      },
      {
        "date": "2026-08-14",
        "close": 70.98
      },
      {
        "date": "2026-08-17",
        "close": 71.14
      },
      {
        "date": "2026-08-18",
        "close": 67.07
      },
      {
        "date": "2026-08-19",
        "close": 66.43
      },
      {
        "date": "2026-08-20",
        "close": 65.06
      },
      {
        "date": "2026-08-21",
        "close": 68.65
      },
      {
        "date": "2026-08-24",
        "close": 62.35
      },
      {
        "date": "2026-08-25",
        "close": 62.01
      },
      {
        "date": "2026-08-26",
        "close": 59.88
      },
      {
        "date": "2026-08-27",
        "close": 61.44
      },
      {
        "date": "2026-08-28",
        "close": 58.05
      },
      {
        "date": "2026-08-31",
        "close": 59.1
      },
      {
        "date": "2026-09-01",
        "close": 55.8
      },
      {
        "date": "2026-09-02",
        "close": 62.4
      },
      {
        "date": "2026-09-03",
        "close": 62.13
      },
      {
        "date": "2026-09-04",
        "close": 62.31
      },
      {
        "date": "2026-09-08",
        "close": 66.12
      },
      {
        "date": "2026-09-09",
        "close": 62.42
      },
      {
        "date": "2026-09-10",
        "close": 59.91
      },
      {
        "date": "2026-09-11",
        "close": 59.86
      },
      {
        "date": "2026-09-14",
        "close": 60.0
      },
      {
        "date": "2026-09-15",
        "close": 58.77
      },
      {
        "date": "2026-09-16",
        "close": 59.27
      },
      {
        "date": "2026-09-17",
        "close": 62.71
      },
      {
        "date": "2026-09-18",
        "close": 58.52
      },
      {
        "date": "2026-09-21",
        "close": 61.89
      },
      {
        "date": "2026-09-22",
        "close": 63.69
      },
      {
        "date": "2026-09-23",
        "close": 59.98
      },
      {
        "date": "2026-09-24",
        "close": 61.06
      },
      {
        "date": "2026-09-25",
        "close": 61.81
      },
      {
        "date": "2026-09-28",
        "close": 61.0
      },
      {
        "date": "2026-09-29",
        "close": 59.4
      },
      {
        "date": "2026-09-30",
        "close": 58.86
      },
      {
        "date": "2026-10-01",
        "close": 57.04
      },
      {
        "date": "2026-10-02",
        "close": 58.45
      },
      {
        "date": "2026-10-05",
        "close": 58.44
      },
      {
        "date": "2026-10-06",
        "close": 63.12
      },
      {
        "date": "2026-10-07",
        "close": 60.65
      },
      {
        "date": "2026-10-08",
        "close": 56.93
      },
      {
        "date": "2026-10-09",
        "close": 50.97
      },
      {
        "date": "2026-10-12",
        "close": 51.46
      }
    ]
  },
  "aurora-autonomous-trucking-fmcsa-warning-beacon-exemption-2026": {
    "symbol": "AUR",
    "company": "Aurora Innovation, Inc.",
    "asOf": "13 October 2026",
    "points": [
      {
        "date": "2026-07-13",
        "close": 6.05
      },
      {
        "date": "2026-07-14",
        "close": 6.13
      },
      {
        "date": "2026-07-15",
        "close": 6.02
      },
      {
        "date": "2026-07-16",
        "close": 5.95
      },
      {
        "date": "2026-07-17",
        "close": 6.06
      },
      {
        "date": "2026-07-20",
        "close": 6.09
      },
      {
        "date": "2026-07-21",
        "close": 6.31
      },
      {
        "date": "2026-07-22",
        "close": 6.61
      },
      {
        "date": "2026-07-23",
        "close": 5.99
      },
      {
        "date": "2026-07-24",
        "close": 5.95
      },
      {
        "date": "2026-07-27",
        "close": 6.21
      },
      {
        "date": "2026-07-28",
        "close": 6.21
      },
      {
        "date": "2026-07-29",
        "close": 5.98
      },
      {
        "date": "2026-07-30",
        "close": 6.24
      },
      {
        "date": "2026-07-31",
        "close": 6.45
      },
      {
        "date": "2026-08-03",
        "close": 6.79
      },
      {
        "date": "2026-08-04",
        "close": 7.23
      },
      {
        "date": "2026-08-05",
        "close": 6.69
      },
      {
        "date": "2026-08-06",
        "close": 6.78
      },
      {
        "date": "2026-08-07",
        "close": 7.06
      },
      {
        "date": "2026-08-10",
        "close": 6.98
      },
      {
        "date": "2026-08-11",
        "close": 6.95
      },
      {
        "date": "2026-08-12",
        "close": 6.87
      },
      {
        "date": "2026-08-13",
        "close": 6.84
      },
      {
        "date": "2026-08-14",
        "close": 6.99
      },
      {
        "date": "2026-08-17",
        "close": 6.97
      },
      {
        "date": "2026-08-18",
        "close": 6.15
      },
      {
        "date": "2026-08-19",
        "close": 6.2
      },
      {
        "date": "2026-08-20",
        "close": 6.12
      },
      {
        "date": "2026-08-21",
        "close": 6.24
      },
      {
        "date": "2026-08-24",
        "close": 5.69
      },
      {
        "date": "2026-08-25",
        "close": 5.77
      },
      {
        "date": "2026-08-26",
        "close": 5.76
      },
      {
        "date": "2026-08-27",
        "close": 5.69
      },
      {
        "date": "2026-08-28",
        "close": 5.83
      },
      {
        "date": "2026-08-31",
        "close": 5.63
      },
      {
        "date": "2026-09-01",
        "close": 5.46
      },
      {
        "date": "2026-09-02",
        "close": 5.85
      },
      {
        "date": "2026-09-03",
        "close": 6.32
      },
      {
        "date": "2026-09-04",
        "close": 6.34
      },
      {
        "date": "2026-09-08",
        "close": 6.51
      },
      {
        "date": "2026-09-09",
        "close": 6.5
      },
      {
        "date": "2026-09-10",
        "close": 6.33
      },
      {
        "date": "2026-09-11",
        "close": 6.43
      },
      {
        "date": "2026-09-14",
        "close": 6.46
      },
      {
        "date": "2026-09-15",
        "close": 6.44
      },
      {
        "date": "2026-09-16",
        "close": 6.36
      },
      {
        "date": "2026-09-17",
        "close": 6.49
      },
      {
        "date": "2026-09-18",
        "close": 6.31
      },
      {
        "date": "2026-09-21",
        "close": 6.51
      },
      {
        "date": "2026-09-22",
        "close": 6.46
      },
      {
        "date": "2026-09-23",
        "close": 6.32
      },
      {
        "date": "2026-09-24",
        "close": 6.06
      },
      {
        "date": "2026-09-25",
        "close": 6.04
      },
      {
        "date": "2026-09-28",
        "close": 5.29
      },
      {
        "date": "2026-09-29",
        "close": 5.39
      },
      {
        "date": "2026-09-30",
        "close": 5.54
      },
      {
        "date": "2026-10-01",
        "close": 5.52
      },
      {
        "date": "2026-10-02",
        "close": 5.67
      },
      {
        "date": "2026-10-05",
        "close": 5.75
      },
      {
        "date": "2026-10-06",
        "close": 5.75
      },
      {
        "date": "2026-10-07",
        "close": 5.72
      },
      {
        "date": "2026-10-08",
        "close": 5.73
      },
      {
        "date": "2026-10-09",
        "close": 5.83
      },
      {
        "date": "2026-10-12",
        "close": 5.66
      }
    ]
  },
  "nvidia-open-ai-factory-standards-ocp-2026": {
    "symbol": "NVDA",
    "company": "NVIDIA Corporation",
    "asOf": "13 October 2026",
    "points": [
      {
        "date": "2026-07-13",
        "close": 203.53
      },
      {
        "date": "2026-07-14",
        "close": 211.8
      },
      {
        "date": "2026-07-15",
        "close": 212.5
      },
      {
        "date": "2026-07-16",
        "close": 207.4
      },
      {
        "date": "2026-07-17",
        "close": 202.81
      },
      {
        "date": "2026-07-20",
        "close": 203.28
      },
      {
        "date": "2026-07-21",
        "close": 207.29
      },
      {
        "date": "2026-07-22",
        "close": 212.06
      },
      {
        "date": "2026-07-23",
        "close": 208.76
      },
      {
        "date": "2026-07-24",
        "close": 206.84
      },
      {
        "date": "2026-07-27",
        "close": 196.51
      },
      {
        "date": "2026-07-28",
        "close": 197.01
      },
      {
        "date": "2026-07-29",
        "close": 190.01
      },
      {
        "date": "2026-07-30",
        "close": 195.04
      },
      {
        "date": "2026-07-31",
        "close": 200.75
      },
      {
        "date": "2026-08-03",
        "close": 206.64
      },
      {
        "date": "2026-08-04",
        "close": 211.94
      },
      {
        "date": "2026-08-05",
        "close": 219.22
      },
      {
        "date": "2026-08-06",
        "close": 218.99
      },
      {
        "date": "2026-08-07",
        "close": 223.96
      },
      {
        "date": "2026-08-10",
        "close": 217.55
      },
      {
        "date": "2026-08-11",
        "close": 217.5
      },
      {
        "date": "2026-08-12",
        "close": 224.09
      },
      {
        "date": "2026-08-13",
        "close": 225.3
      },
      {
        "date": "2026-08-14",
        "close": 225.16
      },
      {
        "date": "2026-08-17",
        "close": 225.01
      },
      {
        "date": "2026-08-18",
        "close": 219.74
      },
      {
        "date": "2026-08-19",
        "close": 217.56
      },
      {
        "date": "2026-08-20",
        "close": 216.85
      },
      {
        "date": "2026-08-21",
        "close": 214.72
      },
      {
        "date": "2026-08-24",
        "close": 208.48
      },
      {
        "date": "2026-08-25",
        "close": 213.05
      },
      {
        "date": "2026-08-26",
        "close": 209.66
      },
      {
        "date": "2026-08-27",
        "close": 227.98
      },
      {
        "date": "2026-08-28",
        "close": 217.55
      },
      {
        "date": "2026-08-31",
        "close": 220.78
      },
      {
        "date": "2026-09-01",
        "close": 217.44
      },
      {
        "date": "2026-09-02",
        "close": 224.41
      },
      {
        "date": "2026-09-03",
        "close": 228.45
      },
      {
        "date": "2026-09-04",
        "close": 230.36
      },
      {
        "date": "2026-09-08",
        "close": 225.73
      },
      {
        "date": "2026-09-09",
        "close": 223.67
      },
      {
        "date": "2026-09-10",
        "close": 218.36
      },
      {
        "date": "2026-09-11",
        "close": 218.29
      },
      {
        "date": "2026-09-14",
        "close": 210.96
      },
      {
        "date": "2026-09-15",
        "close": 212.17
      },
      {
        "date": "2026-09-16",
        "close": 213.9
      },
      {
        "date": "2026-09-17",
        "close": 219.34
      },
      {
        "date": "2026-09-18",
        "close": 222.27
      },
      {
        "date": "2026-09-21",
        "close": 227.38
      },
      {
        "date": "2026-09-22",
        "close": 228.87
      },
      {
        "date": "2026-09-23",
        "close": 225.51
      },
      {
        "date": "2026-09-24",
        "close": 224.58
      },
      {
        "date": "2026-09-25",
        "close": 225.07
      },
      {
        "date": "2026-09-28",
        "close": 228.86
      },
      {
        "date": "2026-09-29",
        "close": 227.21
      },
      {
        "date": "2026-09-30",
        "close": 228.38
      },
      {
        "date": "2026-10-01",
        "close": 230.86
      },
      {
        "date": "2026-10-02",
        "close": 233.95
      },
      {
        "date": "2026-10-05",
        "close": 238.9
      },
      {
        "date": "2026-10-06",
        "close": 239.24
      },
      {
        "date": "2026-10-07",
        "close": 237.47
      },
      {
        "date": "2026-10-08",
        "close": 230.48
      },
      {
        "date": "2026-10-09",
        "close": 229.28
      },
      {
        "date": "2026-10-12",
        "close": 226.32
      }
    ]
  },
  "tesla-flying-roadster-spacex-merger-2026": {
  "symbol": "TSLA",
  "company": "Tesla, Inc.",
  "asOf": "16 October 2026",
  "points": [
    {
      "date": "2026-07-16",
      "close": 391.06
    },
    {
      "date": "2026-07-17",
      "close": 380.84
    },
    {
      "date": "2026-07-20",
      "close": 369.57
    },
    {
      "date": "2026-07-21",
      "close": 378.93
    },
    {
      "date": "2026-07-22",
      "close": 374.01
    },
    {
      "date": "2026-07-23",
      "close": 319.69
    },
    {
      "date": "2026-07-24",
      "close": 313.03
    },
    {
      "date": "2026-07-27",
      "close": 309.22
    },
    {
      "date": "2026-07-28",
      "close": 307.44
    },
    {
      "date": "2026-07-29",
      "close": 298.32
    },
    {
      "date": "2026-07-30",
      "close": 308.85
    },
    {
      "date": "2026-07-31",
      "close": 311.21
    },
    {
      "date": "2026-08-03",
      "close": 322.08
    },
    {
      "date": "2026-08-04",
      "close": 327.35
    },
    {
      "date": "2026-08-05",
      "close": 321.55
    },
    {
      "date": "2026-08-06",
      "close": 319.53
    },
    {
      "date": "2026-08-07",
      "close": 328.58
    },
    {
      "date": "2026-08-10",
      "close": 330.88
    },
    {
      "date": "2026-08-11",
      "close": 332.81
    },
    {
      "date": "2026-08-12",
      "close": 327.51
    },
    {
      "date": "2026-08-13",
      "close": 339.96
    },
    {
      "date": "2026-08-14",
      "close": 342.27
    },
    {
      "date": "2026-08-17",
      "close": 339.3
    },
    {
      "date": "2026-08-18",
      "close": 336.87
    },
    {
      "date": "2026-08-19",
      "close": 351.12
    },
    {
      "date": "2026-08-20",
      "close": 345.13
    },
    {
      "date": "2026-08-21",
      "close": 362.86
    },
    {
      "date": "2026-08-24",
      "close": 348.95
    },
    {
      "date": "2026-08-25",
      "close": 350.25
    },
    {
      "date": "2026-08-26",
      "close": 345.82
    },
    {
      "date": "2026-08-27",
      "close": 354.81
    },
    {
      "date": "2026-08-28",
      "close": 348.75
    },
    {
      "date": "2026-08-31",
      "close": 367.95
    },
    {
      "date": "2026-09-01",
      "close": 356.09
    },
    {
      "date": "2026-09-02",
      "close": 357.01
    },
    {
      "date": "2026-09-03",
      "close": 376.37
    },
    {
      "date": "2026-09-04",
      "close": 354.08
    },
    {
      "date": "2026-09-08",
      "close": 368.16
    },
    {
      "date": "2026-09-09",
      "close": 367.81
    },
    {
      "date": "2026-09-10",
      "close": 363.56
    },
    {
      "date": "2026-09-11",
      "close": 365.44
    },
    {
      "date": "2026-09-14",
      "close": 358.97
    },
    {
      "date": "2026-09-15",
      "close": 356.58
    },
    {
      "date": "2026-09-16",
      "close": 358.08
    },
    {
      "date": "2026-09-17",
      "close": 366.2
    },
    {
      "date": "2026-09-18",
      "close": 364.27
    },
    {
      "date": "2026-09-21",
      "close": 375.3
    },
    {
      "date": "2026-09-22",
      "close": 378.9
    },
    {
      "date": "2026-09-23",
      "close": 380.12
    },
    {
      "date": "2026-09-24",
      "close": 377.94
    },
    {
      "date": "2026-09-25",
      "close": 372.11
    },
    {
      "date": "2026-09-28",
      "close": 357.45
    },
    {
      "date": "2026-09-29",
      "close": 352.84
    },
    {
      "date": "2026-09-30",
      "close": 354.81
    },
    {
      "date": "2026-10-01",
      "close": 354.11
    },
    {
      "date": "2026-10-02",
      "close": 370.59
    },
    {
      "date": "2026-10-05",
      "close": 378.73
    },
    {
      "date": "2026-10-06",
      "close": 380.68
    },
    {
      "date": "2026-10-07",
      "close": 377.81
    },
    {
      "date": "2026-10-08",
      "close": 375.0
    },
    {
      "date": "2026-10-09",
      "close": 382.7
    },
    {
      "date": "2026-10-12",
      "close": 378.03
    },
    {
      "date": "2026-10-13",
      "close": 375.23
    },
    {
      "date": "2026-10-14",
      "close": 367.16
    },
    {
      "date": "2026-10-15",
      "close": 362.44
    },
    {
      "date": "2026-10-16",
      "close": 358.51
    }
  ]
},
} as const;
